<div class="input-btn-wrapper">
  <input type="text" class="form-control" [id]="id" [placeholder]="question.hint | translate | async"
    [(ngModel)]="item" (ngModelChange)="onInputChange($event)" (blur)="onTouched()" />
  @if (showbtn) {
    @for (btn of buttons; track btn) {
    <button type="button" [ngClass]="btn.class_name" (click)="onButtonClick(btn)">
      {{ btn.label | translate | async }}
    </button>
  }
  }
</div>
